export const SET_TRANSLATIONS = "SET_TRANSLATIONS"

export const setTranslations = (translations: any) => {
    return { type: SET_TRANSLATIONS,  content: {translations } }
}

